import { styled } from "@mui/material"

export const PropertyLabel = styled('div')`
	color: #7E8996;
	font-size: 12px;
	width: 54px;
`
